module.exports = __webpack_public_path__ + "static/media/GrabWebIcon-v1.7.0.6705c400.woff2";